"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createApiSelectorMiddleware;

var _reduxApiMiddleware = require("redux-api-middleware");

var _endpoint = _interopRequireDefault(require("./endpoint.middleware"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function prefixEndpoint(endpoint, _ref) {
  var apiUrl = _ref.apiUrl,
      excluded = _ref.excluded;

  if (typeof endpoint === 'function' || excluded.some(function (prefix) {
    return endpoint.startsWith(prefix);
  })) {
    return endpoint;
  }

  var baseUrl = apiUrl.replace(/\/$/, '');
  var slug = endpoint.replace(/^\//, '');
  return "".concat(baseUrl, "/").concat(slug);
}

function createApiSelectorMiddleware(config) {
  return function () {
    return function (next) {
      return function (action) {
        var apiCall = action[_reduxApiMiddleware.RSAA];

        if (!apiCall) {
          return next(action);
        }

        var _apiCall$api = apiCall.api,
            api = _apiCall$api === void 0 ? 'default' : _apiCall$api,
            rest = _objectWithoutProperties(apiCall, ["api"]);

        if (api && !config.apis[api]) {
          throw new Error("You must specify ".concat(api, " url in apis config option"));
        }

        var _config$apis$api = config.apis[api],
            apiUrl = _config$apis$api.apiUrl,
            apiOptions = _objectWithoutProperties(_config$apis$api, ["apiUrl"]);

        var endpoint = prefixEndpoint(apiCall.endpoint, {
          apiUrl: apiUrl,
          excluded: config.excluded
        });
        return (0, _endpoint.default)(endpoint, apiOptions)(next)(_defineProperty({}, _reduxApiMiddleware.RSAA, _objectSpread({}, rest)));
      };
    };
  };
}